<template>
  <header class="app-header">
    <div class="app-header__content">
      <div class="app-header__logo">
        <router-link :to="{ name: 'home' }" id="pl-logo">
          <img src="@/assets/branding/logo2.svg" />
        </router-link>
      </div>
      <div class="app-header__nav">
        <app-main-nav></app-main-nav>
      </div>
      <div class="app-header__side">
        <div
          v-if="isLoggedIn"
          :class="notificationsIconModifiers"
          @click.stop="onNotificationsClick"
        >
          <div v-if="showUnreadNotificationCount" class="app-header__notifications-count">
            {{ userUnreadNotificationsCountHeader }}
          </div>
        </div>
        <transition name="app-header__notifications-widget">
          <div v-if="showNotificationsWidget" class="app-header__notifications-widget">
            <notifications-widget></notifications-widget>
          </div>
        </transition>
        <hamburger-icon class="app-header__burger" v-if="isLayoutMobile"></hamburger-icon>
        <div class="app-header__menu" v-if="isLayoutDesktop">
          <template v-if="isLoggedIn && showBalanceHeader">
            <router-link :to="{ name: 'portfolio' }" custom v-slot="{ navigate }">
              <div
                id="investment"
                class="app-header__menu-item app-header__menu-item--investment app-header__menu-item--border-right"
                @click="navigate"
              >
                <div
                  class="app-header__menu-item-value"
                  v-price-display.floor.fixedflex="balance.portfolioBalanceDecimal"
                ></div>
                <div class="app-header__menu-item-text">Investment</div>
              </div>
            </router-link>
            <div
              id="cash"
              @click.prevent="onCashClick"
              class="app-header__menu-item app-header__menu-item--cash app-header__menu-item--border-right"
            >
              <div
                class="app-header__menu-item-value"
                v-price-display.floor.fixedflex="balance.accountBalanceDecimal"
              ></div>
              <div class="app-header__menu-item-text">Cash</div>
            </div>
            <div id="nav-deposit" :class="depositClassModifiers" @click.prevent="openDepositPopup">
              <div
                class="app-header__menu-item-icon app-header__menu-item-icon--deposit app-header__menu-item--border-right"
              ></div>
              <div class="app-header__menu-item-text">Deposit</div>
            </div>
          </template>
          <template v-else-if="!isLoggedIn">
            <header-search></header-search>
            <div
              id="signup"
              v-if="!isUserRestricted"
              class="app-header__menu-item app-header__menu-item--register app-header__menu-item--border-right"
              @click="onSignUp"
            >
              <div>SIGN UP</div>
            </div>
            <div
              id="login"
              class="app-header__menu-item app-header__menu-item--login"
              @click="onLogin"
            >
              <div>LOGIN</div>
            </div>
          </template>
          <div
            v-if="!isUserRestricted && isLoggedIn"
            class="app-header__menu-item app-header__menu-item--search"
            id="search"
            @click="toggleSearchBar"
          >
            <div class="app-header__menu-item-icon app-header__menu-item-icon--search" />
            <div class="app-header__menu-item-text">Search</div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script src="./app-header.js"></script>
<style src="./app-header.scss" lang="scss"></style>
